import React, { Component } from 'react'
import { observer, inject, PropTypes as mobxPropTypes } from 'mobx-react'
import { formatDate, calculateTotalNetAmount, formatNumber } from '@atheneum/api/dist/lib'
import { Link, withRouter } from 'react-router-dom'
import { StatusLabel } from '@components/StatusLabel'
import PropTypes from 'prop-types'

class InvoicesTable extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    atheneumOfficeStore: PropTypes.object,
    invoices: PropTypes.oneOfType([
      PropTypes.array,
      mobxPropTypes.observableArray
    ]),
    match: PropTypes.object
  }

  renderInvoices = () => {
    const { staticData, atheneumOfficeStore, match, invoices = [] } = this.props

    const invoiceElements = invoices.map(invoice => {
      const atheneumOffice = atheneumOfficeStore.atheneumOffices.find(
        office => office.id === invoice.atheneumOfficeId
      )
      const documentDate = invoice.documentDate
        ? formatDate(invoice.documentDate)
        : '-'
      const invoiceLink = match.url + '/' + invoice.id

      const totalNetAmount = calculateTotalNetAmount(invoice)
      const readableCurrency =
        staticData.names.currencies[invoice.currencyId] || ''

      const classes = invoice.isCreditNote ? 'red-text' : ''

      return (
        <tr key={invoice.id} className={classes}>
          <td>
            <span className='text-wrapper'>
              <Link to={invoiceLink}>{invoice.name}
                {invoice.isENSInvoice && <>&nbsp;<span>(ENS {invoice.isFreeCallInvoice && 'free calls '}Invoice)</span></>}
                {invoice.isCapiCallOnlyInvoice && <>&nbsp;<span>(ENS API calls only)</span></>}
              </Link>
            </span>
          </td>
          <td>
            <span className='text-wrapper'>{documentDate}</span>
          </td>
          <td>
            <StatusLabel
              statusId={invoice.invoiceStatusId}
              statusesType='invoiceStatuses'
              data-cy='invoice-status-label'
            />
          </td>
          <td>
            <span className='text-wrapper'>
              {formatNumber(totalNetAmount)} {readableCurrency}
            </span>
          </td>
          <td>
            <span className='text-wrapper'>{atheneumOffice.name}</span>
          </td>
          <td>
            <span className='text-wrapper'>
              {invoice.approvedBy ? invoice.approvedBy.fullName : '-'}
            </span>
          </td>
        </tr>
      )
    })

    return <tbody>{invoiceElements}</tbody>
  }

  render() {
    return (
      <table className='table-wrapper invoice-table'>
        <thead>
          <tr>
            <th>Invoice No.</th>
            <th>Document date</th>
            <th>Status</th>
            <th>Net Amount</th>
            <th>Atheneum company</th>
            <th style={{ width: '90px' }}>Approved by</th>
          </tr>
        </thead>
        {this.renderInvoices()}
      </table>
    )
  }
}

export default withRouter(
  inject('staticData', 'atheneumOfficeStore')(observer(InvoicesTable))
)
